import { ApiParameters } from './api-parameters';
import { TrackingChannel } from '../../enums/tracking-channel';
import { ApiPostRequest } from './api-post-request';
import { TicketInstance } from '../../interfaces/ticket-instance';

export class CreateSmtOrderRequest extends ApiPostRequest
{
    public constructor(smtInstances: TicketInstance[], webapiBasepath: string, referrer?: string, browser?: string, platform?: string, version?: string, trackingChannel?: TrackingChannel)
    {
        super(  'order/createsmtorder', 
                new ApiParameters(), 
                null, 
                {
                    'SMTInstances': smtInstances,
                    'referrer': referrer,
                    'browser': browser,
                    'platform': platform,
                    'version': version,
                    'trackingChannel': trackingChannel
                },
                webapiBasepath
        );
    }
}
